import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	ticketStatusToDo: {
		id: 'fastshift.dashboard.roll-up-status.to-do',
		defaultMessage: 'TO DO',
		description: 'Status label for TO_DO status',
	},
	ticketStatusOnTrack: {
		id: 'fastshift.dashboard.roll-up-status.on-track',
		defaultMessage: 'ON TRACK',
		description: 'Status label for ON_TRACK status',
	},
	ticketStatusComplete: {
		id: 'fastshift.dashboard.roll-up-status.complete',
		defaultMessage: 'COMPLETED',
		description: 'Status label for COMPLETE status',
	},
	ticketStatusAtRiskAtlassianOwned: {
		id: 'fastshift.dashboard.roll-up-status.at-risk-atlassian-owned',
		defaultMessage: 'AT RISK - OWNED BY ATLASSIAN',
		description: 'Status label for AT_RISK_ATLASSIAN_OWNED status',
	},
	ticketStatusAtRiskPartnerOwned: {
		id: 'fastshift.dashboard.roll-up-status.at-risk-partner-owned',
		defaultMessage: 'AT RISK - OWNED BY PARTNER',
		description: 'Status label for AT_RISK_PARTNER_OWNED status',
	},
	ticketStatusNeedsCustomerAttention: {
		id: 'fastshift.dashboard.roll-up-status.needs-customer-attention',
		defaultMessage: 'NEEDS CUSTOMER ATTENTION',
		description: 'Status label for NEEDS_CUSTOMER_ATTENTION status',
	},
	ticketStatusUnknown: {
		id: 'fastshift.dashboard.roll-up-status.unknown',
		defaultMessage: 'UNKNOWN STATUS',
		description: 'Fallback status label for unknown status values to prevent UI crashes',
	},
	assessmentPending: {
		id: 'fastshift.organization-details.dc-instances.assessment.pending',
		defaultMessage: 'Pending',
		description: 'Assessment status for a pending Data Center instance assessment.',
	},
	assessmentInProgress: {
		id: 'fastshift.organization-details.dc-instances.assessment.in-progress',
		defaultMessage: 'In progress',
		description: 'Assessment status for a Data Center instance assessment in progress.',
	},
	assessmentUpdating: {
		id: 'fastshift.organization-details.dc-instances.assessment.updating',
		defaultMessage: 'Updating',
		description: 'Assessment status for a Data Center instance assessment being updated.',
	},
	assessmentUpToDate: {
		id: 'fastshift.organization-details.dc-instances.assessment.up-to-date',
		defaultMessage: 'Up to date',
		description: 'Assessment status for an up-to-date Data Center instance assessment.',
	},
	assessmentActionRequired: {
		id: 'fastshift.organization-details.dc-instances.assessment.action-required',
		defaultMessage: 'Action required',
		description: 'Assessment status when a Data Center instance assessment requires action.',
	},
	assessmentHasErrors: {
		id: 'fastshift.organization-details.dc-instances.assessment.has-errors',
		defaultMessage: 'Has errors',
		description: 'Assessment status when a Data Center instance assessment has errors.',
	},
	assessmentNoData: {
		id: 'fastshift.organization-details.dc-instances.assessment.no-data',
		defaultMessage: 'No data',
		description: 'Assessment status when a Data Center instance assessment has no data.',
	},
	assessmentOutdated: {
		id: 'fastshift.organization-details.dc-instances.assessment.outdated',
		defaultMessage: 'Outdated',
		description: 'Assessment status when a Data Center instance assessment is outdated.',
	},
	assessmentNotAvailable: {
		id: 'fastshift.organization-details.dc-instances.assessment.not-available',
		defaultMessage: 'Not available',
		description: 'Fallback label when a Data Center instance assessment status is unavailable.',
	},
	connectionConnected: {
		id: 'fastshift.organization-details.dc-instances.connection.connected',
		defaultMessage: 'Connected',
		description: 'Connection status for a connected Data Center instance.',
	},
	connectionInitialized: {
		id: 'fastshift.organization-details.dc-instances.connection.initialized',
		defaultMessage: 'Initialized',
		description: 'Connection status for an initialized Data Center instance.',
	},
	connectionRegenerating: {
		id: 'fastshift.organization-details.dc-instances.connection.regenerating',
		defaultMessage: 'Regenerating',
		description: 'Connection status for a Data Center instance regenerating its connection.',
	},
	connectionDisconnected: {
		id: 'fastshift.organization-details.dc-instances.connection.disconnected',
		defaultMessage: 'Disconnected',
		description: 'Connection status for a disabled Data Center instance connection.',
	},
	connectionExpired: {
		id: 'fastshift.organization-details.dc-instances.connection.expired',
		defaultMessage: 'Expired',
		description: 'Connection status for an expired Data Center instance connection.',
	},
	connectionInterrupted: {
		id: 'fastshift.organization-details.dc-instances.connection.interrupted',
		defaultMessage: 'Interrupted',
		description: 'Connection status for an interrupted Data Center instance connection.',
	},
	connectionFailed: {
		id: 'fastshift.organization-details.dc-instances.connection.failed',
		defaultMessage: 'Failed',
		description: 'Connection status for a failed Data Center instance connection.',
	},
	connectionOffline: {
		id: 'fastshift.organization-details.dc-instances.connection.offline',
		defaultMessage: 'Offline',
		description: 'Connection status for an offline Data Center instance connection.',
	},
	connectionUnknown: {
		id: 'fastshift.organization-details.dc-instances.connection.unknown',
		defaultMessage: 'Unknown',
		description: 'Fallback connection status for an unrecognized Data Center instance status.',
	},
});
